import React from 'react'
import { useTranslation } from 'react-i18next';
import ProgressBar from '../../partials/ProgressBar'
import TwoCol from '../../partials/TwoCol'

function KnowledgeSection() {
    const { t } = useTranslation();

    return (
        <section className="container bg-light d-none">
            <h2 className='text-center'>{t('rateKnowledge')}</h2>
            <TwoCol contentOne={<First />} contentTwo={<Second />} />
            <div className='text-center my-50'>
                <h3 className='knSubtitle text-center'>{t('uiUxDesign')}</h3>
                <ProgressBar percentage={85} backgroundColor={"#7a92ff"} />
            </div>
            <div className='text-center my-50'>
                <h3 className='knSubtitle text-center'>"HTML/CSS/SASS"</h3>
                <ProgressBar percentage={85} backgroundColor={"#fad55d"} />
            </div>
        </section>
    )
}

export default KnowledgeSection

function First() {
    const { t } = useTranslation();

    return(
        <>
            <h3 className='knSubtitle text-center'>{t('graphicDesign')}</h3>
            <ProgressBar percentage={70} backgroundColor={"#f55f78"} />
        </>
    );
}

function Second() {
    const { t } = useTranslation();

    return(
        <>
            <h3 className='knSubtitle text-center'>{t('reactDev')}</h3>
            <ProgressBar percentage={45} backgroundColor={"#25e6cf"}  />
        </>
    );
}